import { useBalance, useReadContracts } from "wagmi";
import useDappConfig from "./useDappConfig";
import { erc20Abi, formatUnits } from "viem";
import { ETH, SFRXETH, TokenDetails } from "@config/contractsConfig";

const useBufferPool = () => {
  const { config } = useDappConfig();

  const tokensObj = {
    ...config.tokens,
    [ETH]: config.nativeToken as any,
  } as TokenDetails;

  const tokens = Object.keys(tokensObj)
    .filter((token) => tokensObj[token].symbol !== SFRXETH)
    .map((token) => tokensObj[token]);

  const { data: assetCommited, refetch: refetchAssetCommited } =
    useReadContracts({
      contracts: tokens.map((token) => ({
        ...config.interactionPools?.lrtWithdrawalManager,
        functionName: "assetsCommitted",
        args: [token.address],
      })),
      query: {
        enabled: !!tokens.length,
        refetchInterval: 10_000,
      },
    });

  const { data: tokensBalances, refetch: refetchTokenBalances } =
    useReadContracts({
      contracts: tokens
        .filter((token) => {
          return token.symbol !== ETH;
        })
        .map((token) => ({
          address: token.address,
          abi: erc20Abi,
          functionName: "balanceOf",
          args: [config.interactionPools?.lrtUnstakingVault?.address],
        })),
    });

  const { data: ethBalance, refetch: refetchEthBalance } = useBalance({
    address: config.interactionPools?.lrtUnstakingVault?.address,
    query: {
      refetchInterval: 10_000,
    },
  });

  const bufferPool: { [x: string]: number } =
    tokensBalances && ethBalance && assetCommited
      ? tokens.reduce((acc, curr, index) => {
          return {
            ...acc,
            [curr.symbol]: Math.max(
              Number(
                curr.symbol === ETH
                  ? formatUnits(ethBalance.value, 18)
                  : tokensBalances[index].result
                  ? formatUnits(tokensBalances[index].result as bigint, 18)
                  : 0n
              ) -
                Number(
                  assetCommited[index].result
                    ? formatUnits(assetCommited[index].result as bigint, 18)
                    : 0n
                ),
              0
            ),
          };
        }, {})
      : {};

  return {
    bufferPool,
    refetchAssetCommited,
    refetchTokenBalances,
    refetchEthBalance,
    // refetchBufferData,
  };
};

export default useBufferPool;
